import GeneralFactory from 'coreClasses/GeneralFactory';
import {ERecommendationsProviders} from './IRecommendationsMgr';
import RecommendationsProvider from './providers/RecommendationsProvider';
import SFCCRecommendationsProvider from './providers/SFCCRecommendationsProvider';
import EinsteinRecommendationsProvider from './providers/EinsteinRecommendationsProvider';

/**
 * Represents RecommendationsProvidersFactory
 */
class RecommendationsProvidersFactory extends GeneralFactory {
	/**
	 * @constructor
	 * @param {String} providerName Provider name
	 * @returns {RecommendationsProvider}
	 */
	create(providerName: ERecommendationsProviders): RecommendationsProvider {
		switch (providerName) {
			case ERecommendationsProviders.EINSTEIN:
				return new EinsteinRecommendationsProvider(this.managerRepository);
			case ERecommendationsProviders.SFCC:
				return new SFCCRecommendationsProvider(this.managerRepository);
			default:
				return null;
		}
	}
}

export default RecommendationsProvidersFactory;
